module.exports = __webpack_public_path__ + "static/media/gamepad-alt.ddd4e2c1.svg";